import { useState, useEffect } from 'react';

import Body from './Body';
import { loadStripe } from '@stripe/stripe-js';

import { useDispatch } from 'react-redux';
import { loadingStart, loadingStop } from 'redux/action';
import API from 'services/api';
import { toast } from 'react-toastify';

export const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_KEY);

const Index = () => {
  const dispatch = useDispatch();
  const [step, setStep] = useState(1);
  const [form, setForm] = useState({});
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [clientSecret, setClientSecret] = useState(null);
  const [loading, setLoading] = useState(false);

  const plans = [
    {
      name: 'Bronze Sponsor',
      price: 2000,
      description: [
        'Logo placement at the reception desk',
        'Logo on sponsorship slide shown at the beginning of each day'
      ]
    },
    {
      name: 'Silver Sponsor',
      price: 4000,
      description: [
        'Logo placement on break tables',
        'Table at the Vendor Expo',
        'Logo at registration and reception desk',
        'Ability to provide branded swag',
        'Swag included in attendee gift bags',
        'Includes all lower tiers'
      ]
    },
    {
      name: 'Gold Sponsor',
      price: 6000,
      description: [
        'Logo displayed between sessions',
        'Logo on attendee name badges',
        'Verbal recognition between presenters',
        'Includes all lower tiers'
      ]
    },
    {
      name: 'Platinum Sponsor',
      price: 10000,
      description: [
        'Premium Vendor Expo placement',
        '15 minute General Session presentation',
        'Keynote Speaker sponsorship',
        'Meet & Greet named for your business',
        'Includes all lower tiers'
      ]
    }
  ];

  // ---------------- VALIDATION ----------------

  const validateStep1 = () => {
    const required = ['name', 'company', 'phone', 'email', 'address', 'city', 'state', 'zip'];

    for (let key of required) {
      if (!form[key] || !form[key].trim()) return false;
    }

    if (!/\S+@\S+\.\S+/.test(form.email)) return false;

    return true;
  };

  const validateStep2 = () => {
    return !!selectedPlan;
  };

  const createPaymentIntentForVegasConference = async (payload) => {
    dispatch(loadingStart());

    try {
      const response = await API.createPaymentIntentForVegasConferenceSponsors(payload);

      if (!response.clientSecret) {
        toast.error('Create Payment Intent Error:', response);
        setStep(2);
        // optionally show toast / notification here
      } else {
        setClientSecret(response.clientSecret);
      }
    } catch (error) {
      toast.error('Create Payment Intent Error:', error);
      setStep(2);
      // optionally show toast / notification here
    } finally {
      dispatch(loadingStop());
    }
  };
  // Create intent when entering step 3
  useEffect(() => {
    if (step === 3 && selectedPlan && !clientSecret) {
      createPaymentIntentForVegasConference({
        ...form,
        tier: selectedPlan.name,
        amount: selectedPlan.price * 100
      });
    }
  }, [step]);

  // Scroll on step change
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [step]);

  const _this = {
    step,
    setStep,
    form,
    setForm,
    plans,
    selectedPlan,
    setSelectedPlan,
    clientSecret,
    loading,
    stripePromise,
    validateStep1,
    validateStep2
  };

  return <Body _this={_this} />;
};

export default Index;
